var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Reload = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 416 456" }, props),
        React.createElement("path", { d: "M67.59 189c0 32.789 11.539 64.691 32.484 89.828 11.789 14.141 9.875 35.164-4.266 46.945-6.231 5.191-13.801 7.73-21.32 7.73-9.551 0-19.035-4.082-25.625-11.992C17.949 284.414.922 237.36.922 189.002c0-97.016 67.066-178.65 157.27-201.01l-8.75-8.754c-13.016-13.016-13.016-34.125 0-47.141s34.125-13.02 47.141 0L263.759-.727c13.016 13.016 13.016 34.125 0 47.141l-67.176 67.176c-6.512 6.512-15.039 9.766-23.574 9.766s-17.062-3.254-23.574-9.766c-13.016-13.02-13.016-34.125 0-47.141l8.703-8.703c-52.879 20.156-90.543 71.383-90.543 131.26L67.59 189zm347.502 0c0-46.645-15.963-92.395-44.947-128.83-11.461-14.41-32.434-16.793-46.836-5.336s-16.793 32.426-5.336 46.836c19.922 25.047 30.457 55.242 30.457 87.332 0 61.535-39.789 113.95-94.988 132.87l10.32-10.32c13.02-13.02 13.02-34.125 0-47.141s-34.121-13.016-47.141 0l-67.188 67.176c-13.016 13.02-13.016 34.125 0 47.141l67.176 67.176c6.512 6.512 15.039 9.766 23.574 9.766 8.527 0 17.062-3.254 23.574-9.766 13.02-13.02 13.02-34.125 0-47.141l-8.195-8.195c91.336-21.547 159.53-103.74 159.53-201.57V189z", fill: color })));
};
Reload.defaultProps = {
    color: '#153255',
};
export default Reload;
//# sourceMappingURL=Reload.js.map